import palette from '@lib/core/src/theme/palette';
import { CircularProgress, Stack, styled, Typography } from '@mui/material';

export const SourceTooltipText = styled(Typography)({
  fontSize: '12px',
  fontWeight: 700,
  color: palette.white
});

export const Description = styled(Typography)({
  fontSize: '12px',
  fontWeight: 500,
  whiteSpace: 'pre-line'
});

const TaskSourceTooltip = ({
  title,
  loading,
  description,
  onClick
}: {
  title: string;
  description?: string;
  loading: boolean;
  onClick: () => void;
}) => (
  <Stack width="100%" alignItems="flex-start" gap="4px">
    <SourceTooltipText>
      Generated from{' '}
      {loading ? (
        <CircularProgress />
      ) : (
        <span style={{ textDecoration: 'underline' }}>{title}</span>
      )}
    </SourceTooltipText>

    {description && <Description>{description}</Description>}
  </Stack>
);

export default TaskSourceTooltip;
